import { NgModule } from '@angular/core';
import { LogEventsComponent } from './log-events.component';
import { LogEventListComponent } from './log-event-list/log-event-list.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LOG_EVENTS_ROUTES } from './log-events.routes';
import { LogEventService } from './shared/log-event.service';

@NgModule({
  imports: [
    RouterModule.forChild(LOG_EVENTS_ROUTES),
    SharedModule
  ],
  declarations: [
    LogEventsComponent,
    LogEventListComponent
  ],
  providers: [
    LogEventService
  ]
})
export class LogEventsModule {
}
